// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import api from './advisorApi';

// Advisor surface for issuing New Business Application requests from an accepted
// proposal. Backed by /api/new-business/requests (tenant via X-Brokerage-Id).
// See docs/specs/new-business-application-prd.md §5.7.

export interface NewBusinessRequestCreated {
  requestId: string;
  status: string;
}

export const newBusinessApi = {
  createRequest: async (proposalId: string): Promise<NewBusinessRequestCreated> =>
    (await api.post('/new-business/requests', { proposalId })).data,
};
